import axios, {AxiosResponse} from 'axios';

import {GifModel, ImageSizesEnum} from '../models/api/gifModel';

function computeGifFilename(gif: GifModel) {
  const name = `gif-${gif.id}`;
  return `${name}.gif`;
}

export async function fetchGifFile(gif: GifModel, imageSize: ImageSizesEnum): Promise<File> {
  const {url} = gif.images[imageSize];
  const blobResponse: AxiosResponse<Blob> = await axios.get(url, {responseType: 'blob'});
  return new File([blobResponse.data], computeGifFilename(gif), {type: 'image/gif'});
}
